<!--  -->
<template>
  <div class="">
    <textarea rows="310" cols="240" style="border: 0;">
        隐私政策

  本版发布日期：2022年1月14日
  生效日期：2022年1月14日

  提示条款
  您的信任对我们非常重要,我们深知个人信息对您的重要性,我们将按法律法规要求，采取相应安全保护措施,尽力保护您的个人信息安全可控。鉴于此，黄埔人才网服务提供者(或简称“我们"）制定本《隐私政策》（下称“本政策/本隐私政策”）并提醒您:
  本政策适用于黄埔人才网提供的所有产品和服务。本政策不适用于您通过我们的产品/服务而接入的其他第三方向您提供的产品/服务(“其他第三方”，包括但不限于您的交易相对方、任何第三方网站以及第三方服务提供者)，也不适用于黄埔人才网中已另行独立设置隐私政策的产品或服务.例如黄埔人才网上展示的商家依托黄埔人才网向您提供服务时，您向商家提供的个人信息不适用本政策。
  在使用黄埔人才网各项产品或服务前,请您务必仔细阅读并透彻理解本政策,特别是以粗体/粗体下划线标识的条款，您应重点阅读,在确认充分理解并同意后再开始使用.如对本政策内容有任何疑问、意见或建议，您可通过黄埔人才网提供的各种联系方式与我们联系。

  第一部分 定义
  黄埔人才网:指“黄埔人才网"小程序。
  黄埔人才网服务提供者：指黄埔人才网的互联网信息及软件技术服务提供者广州首信人力资源有限公司。     个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
  个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全,极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。通常情况下，14岁以下（含）儿童的个人信息和自然人的隐私信息属于个人敏感信息。
  个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为,使其保持不可被检索、访问的状态。 
  第二部分 隐私政策
  本隐私政策部分将帮助您了解以下内容：
  一、我们如何收集和使用您的个人信息
  二、我们如何使用Cookie和同类技术
  三、我们如何共享、转让、公开披露您的个人信息
  四、我们如何保护您的个人信息 五、您的权利 六、我们如何处理未成年人的个人信息 七、本隐私政策如何更新 八、如何联系我们


  一、我们如何收集和使用您的个人信息
  在您使用我们的产品及/或服务时,我们需要/可能需要收集和使用的您的个人信息包括如下两种：
  1.为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息,您将无法正常使用我们的产品及/或服务；
  2.为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用的信息.如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。
  您理解并同意：
  1.我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多,且不同用户选择使用的具体产品/服务范围存在差异，相应的,基本/附加功能及收集使用的个人信息类型、范围等会有所区别,请以具体的产品/服务功能为准；
  2.为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术,随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。在此过程中,如果您有任何疑问、意见或建议的，您可通过黄埔人才网提供的各种联系方式与我们联系，我们会尽快为您作出解答。

  我们会为实现本政策下述的各项功能,收集和使用您的个人信息：

  (一）帮助您成为我们的会员
  我们通过黄埔人才网账户为您提供基础会员服务.为注册成为会员并使用我们的会员服务，我们将根据您的授权通过微信获取您的昵称、头像、地区及性别，收集这些信息是为了帮助您完成注册成为会员。

  （二）为您提供商品或服务信息展示
  在您使用我们服务过程中，为了解产品适配性、识别账号异常状态、向您提供更契合您需求的页面展示和搜索结果，我们可能会请求您提供或自动收集您的使用情况并储存为网络日志信息，包括:
  位置信息：当您通过系统授权开启移动设备的定位功能并使用基于位置提供的服务时，我们会收集和使用您的位置信息以便为您展示周边的服务(例如您不需要手动输入所在地理位置就可获得相关服务，估算服务人员与您之间的实际距离方便您进行决策，为您展示附近的服务品类和优惠信息等)。我们会使用有关技术获取您的位置信息(准确度会有所不同)，这些技术包括IP地址、GPS以及能够提供相关信息的WLAN(如Wi-Fi) 接入点、蓝牙和基站等。您可以在移动设备的系统中关闭定位服务停止我们对您所在位置信息的收集，但可能因此无法使用我们基于地理位置为您提供的服务，或者无法达到相关服务的预期效果。上述位置信息将会储存于中华人民共和国境内。如需要跨境传输，我们将会单独征得您的授权同意。
    设备信息：我们会根据您在软件使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、使用的移动应用和其他软件信息等软硬件特征信息）、设备所在位置相关信息(包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）.
  服务日志信息：当您使用我们的小程序提供的产品或服务时,我们会自动收集您对我们服务的详细使用情况，作为服务日志保存.包括浏览、点击查看、搜索查询、收藏、添加至购物车、交易、售后、分享信息、发布信息,以及IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间。
  请注意，单独的设备信息、日志信息、位置信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份,或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息,除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务,我们会根据您的设备信息、位置信息和服务日志信息,提取您的偏好特征，并基于特征标签进行间接人群画像，展示、推送信息和可能的商业广告。
  此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。

  （三）为您提供分享功能
  在您浏览我们小程序的过程中,您可以选择对感兴趣的商品及/或服务通过我们提供的功能组件向其他第三方分享信息.在您使用上述功能的过程中,我们会收集包括您的分享历史在内的服务日志信息用于实现上述功能及其他我们明确告知的目的。 

  （四）帮助您完成下单及订单管理
  当您在我们的产品及/或服务中订购具体商品及/或服务时,我们会通过系统为您生成购买该商品及/或服务的订单。该订单中会载明您所购买的商品及/或服务信息、具体订单号、下单时间、您应支付的金额、支付方式、二维码，我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客服与售后服务及其他我们明确告知的目的。
  为便于您了解查询订单信息并对订单详细信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。

  (五）帮助您完成支付
  为完成交易，您需要选择微信支付并提供相应支付账号，我们会将您的订单号、订单交易金额信息、订单状态与您选择的付款方式所对应的支付机构共享.
  为使我们及时获悉并确认您的支付进度及状态，为您提供售后及争议解决服务，您同意我们可自您选择的交易对象、支付方式所对应的支付机构处收集与支付账号、支付进度相关的信息。

  （六)客服及争议处理
  当您与我们联系或提出售中售后、争议纠纷处理申请时，为了保障您的账号及系统安全,我们需要您提供必要的个人信息以核验您的用户身份。
  为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果,我们可能会保存您与我们的通信/通话记录及相关内容（包括账号信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账号信息和订单信息。
  为了提供服务及改进服务质量的合理需要,我们还可能使用的您的其他信息,包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息.

  （七)邀请好友
  您可以通过分享功能向您的好友分享我们提供的产品和/或服务，与此同时,我们需要记录您的黄埔人才网账号昵称及头像、手机号码、设备信息、微信账号.

  (八）为您提供安全保障
  为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性,确保操作环境安全与识别会员账号异常状态，更好地保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险,更准确地识别违反法律法规或黄埔人才网相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。

  (九）其他
  1.若你提供的信息中含有其他用户的个人信息，在向黄埔人才网提供这些个人信息之前,您需确保您已经取得合法的授权。
  2.若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意.
  若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认,要求第三方对个人信息来源的合法性和合规性作出承诺,如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。
  3.征得授权同意的例外
  您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：
  （1）与国家安全、国防安全有关的；
  （2）与公共安全、公共卫生、重大公共利益有关的；
  （3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；
  （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
  （5）您自行向社会公众公开的个人信息；
  （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道.
  （7）根据与您签订和履行相关协议或其他书面文件所必需的；
  （8）用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障;
  （9）为合法的新闻报道所必需的；
  （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时,对结果中所包含的个人信息进行去标识化处理的;
  （11）法律法规规定的其他情形。
  请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善黄埔人才网的内容和布局，为商业决策提供产品或服务支撑,以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），则此类处理后数据的使用无需另行向您通知并征得您的同意。
  4.如我们停止运营黄埔人才网产品或服务，我们将及时停止继续收集您个人信息的活动,将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。
  二、我们如何使用 Cookie 和同类技术
  为确保产品和服务正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符.借助于Cookie,网站能够存储您的偏好数据。     您可根据自己的偏好管理或删除Cookie.您可以清除移动设备上保存的所有Cookie。 

  三、我们如何共享、转让、公开披露您的个人信息
  （一）共享     我们不会与黄埔人才网服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外:     1.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息.     2.在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息.     3.与关联公司间共享：为便于我们基于关联账号共同向您提供服务,推荐您可能感兴趣的信息或保护我们关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息,如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的,将再次征求您的授权同意。     4.与授权合作伙伴共享：仅为实现本隐私政策中声明的目的,我们的某些服务将由我们和授权合作伙伴共同提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。     目前,我们的授权合作伙伴包括以下类型：     (1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息,例如姓名或手机号码,通过这些信息可以联系到您或识别您的身份)与提供广告、分析服务的合作伙伴共享。我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息,或者我们将这些信息进行汇总，以便它不会识别您个人。例如,只有在广告主同意遵守我们的广告发布准则后，我们才可能会告诉广告主他们广告的效果如何，或者有多少人看了他们广告或在看到广告后安装了应用,或者向这些合作伙伴提供不能识别个人身份的统计信息(例如“男性，25—29岁，位于北京”）,帮助他们了解其受众或顾客。     (2)供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴,这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。     对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的数据保护协定,要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
  （二）转让     我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外:     1.在获取明确同意的情况下转让：获得您的明确同意后,我们会向其他方转让您的个人信息；     2.在黄埔人才网服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
  （三）公开披露     我们仅会在以下情况下，公开披露您的个人信息：     1.获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息;     2.如果我们确定您出现违反法律法规或严重违反黄埔人才网相关协议规则的情况，或为保护黄埔人才网及其关联公司用户或公众的人身财产安全免遭侵害,我们可能依据法律法规或黄埔人才网相关协议规则征得您同意的情况下披露关于您的个人信息,包括相关违规行为以及黄埔人才网已对您采取的措施。
  （四）共享、转让、公开披露个人信息时事先征得授权同意的例外     以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：     1.与国家安全、国防安全有关的；     2.与公共安全、公共卫生、重大公共利益有关的；     3.与犯罪侦查、起诉、审判和判决执行等有关的;     4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；     5.您自行向社会公众公开的个人信息；     6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。     根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。 
  四、我们如何保护您的个人信息
  （一）我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。     （二)我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。
  (三）我们会采取合理可行的措施,尽力避免收集无关的个人信息.我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许.     (四）互联网并非绝对安全的环境,我们强烈建议您不要使用非黄埔人才网推荐的通信方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象,作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。     如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络黄埔人才网客服，以便我们根据您的申请采取相应措施。     请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。     我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏,导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。     (五）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过黄埔人才网公告方式获得。     （六）在不幸发生个人信息安全事件后,我们将按照法律法规的要求向您告知:安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。

  五、您如何管理您的个人信息
  您可以通过以下方式访问及管理您的个人信息：
  （一）访问您的个人信息     您有权访问您的个人信息，法律法规规定的例外情况除外.具体访问路径以黄埔人才网相应产品或服务内提供的为准.     （二）更正或补充您的个人信息     当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。     （三)删除您的个人信息     在以下情形中，您可以向我们提出删除个人信息的请求：     1.如果我们处理个人信息的行为违反法律法规;     2.如果我们收集、使用您的个人信息,却未征得您的明确同意；     3.如果我们处理个人信息的行为严重违反了与您的约定；     4.如果您不再使用我们的产品或服务，或您主动注销了账号；     5.如果我们永久不再为您提供产品或服务。     若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体,要求其及时删除,除非法律法规另有规定，或这些主体获得您的独立授权。     当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息,但会在备份更新时删除这些信息。     （四）改变您授权同意的范围     每个业务功能需要一些基本的个人信息才能得以完成（见本隐私政策“第二部分第一条”）。除此之外，对于额外个人信息的收集和使用,您可以与客服联系给予或收回您的授权同意。     当您收回同意后，我们将不再处理相应的个人信息.但您收回同意的决定,不会影响此前基于您的授权而开展的个人信息处理。     （五）个人信息主体注销账户
  您随时可以注销此前注册的账户，您可以通过以下方式自行操作:
  进入小程序-“我的”-“设置”页面进行注销，或联系客服进行注销。
  在注销账户之后，我们将停止为您提供产品或服务,并依据您的要求，删除您的个人信息，法律法规另有规定的除外。
  （六)约束信息系统自动决策     在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害黄埔人才网商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。     （七）响应您的上述请求     为保障安全，您可能需要提供书面请求,或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。     我们将在15天内做出答复。如您不满意，还可以通过黄埔人才网客服发起投诉。     对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段(例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。     在以下情形中，按照法律法规要求，我们将无法响应您的请求：     1.与国家安全、国防安全有关的；     2.与公共安全、公共卫生、重大公共利益有关的；     3.与犯罪侦查、起诉、审判和执行判决等有关的;     4.有充分证据表明个人信息主体存在主观恶意或滥用权利的；     5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；     6.涉及商业秘密的。 
  六、我们如何处理未成年人的个人信息     若您是未满18周岁的未成年人，在使用黄埔人才网及相关服务前,应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。
    我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、储存、共享、转让或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息,则会设法尽快删除相关信息。
    若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时,请通过公司本隐私政策公示的联系方式与我们联系。
    
  七、本隐私政策如何更新     我们的隐私政策可能变更。     未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。有关隐私政策的任何变更,我们会通过黄埔人才网公示等方式提前通知您。     
  八、如何联系我们     如您对本隐私政策或您个人信息的相关事宜有任何问题、意见、建议、投诉，请通过访问黄埔人才网小程序中的客服与我们联系,我们将在15天内回复您的请求。 
  九、争议解决
  1、本《隐私政策》的解释及争议解决均应适用中华人民共和国大陆地区法律。如双方就本条款内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向广州市黄埔区人民法院提起诉讼。 
  2、本《隐私政策》的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。



      </textarea>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="less" scoped>
</style>
